// Tuto funkci použijte pro upravení původního chování countdown timeru
// Toto je bezpečnější přístup, který nekonfliktuje s původním kódem

// Počkáme na kompletní načtení dokumentu
document.addEventListener('DOMContentLoaded', function() {
  console.log("Daily countdown modifier initialized");
  
  // Hledáme všechny countdowny na stránce
  const countdowns = document.querySelectorAll('.countd_all');
  
  // Procházíme každý countdown
  countdowns.forEach(function(countdown) {
    // Získáme aktuální data-date atribut
    const origDate = countdown.getAttribute('data-date');
    
    // Pokud je atribut prázdný nebo chceme vždy použít denní reset,
    // nastavíme nový datum na zítřejší půlnoc
    if (!origDate || origDate.trim() === '' || countdown.getAttribute('data-daily-reset') === 'true') {
      // Vytvoříme zítřejší datum v půlnoci
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);
      
      // Formátujeme datum ve formátu, který očekává původní skript (YYYY/MM/DD)
      const year = tomorrow.getFullYear();
      const month = (tomorrow.getMonth() + 1).toString().padStart(2, '0');
      const day = tomorrow.getDate().toString().padStart(2, '0');
      
      // Nastavíme nové datum
      const newDate = `${year}/${month}/${day}`;
      countdown.setAttribute('data-date', newDate);
      
      console.log("Countdown nastaven na:", newDate);
    }
  });
});

// Funkce pro opětovné nastavení countdownu při vypršení
// Tato funkce může být volána původním skriptem po vypršení času
window.resetDailyCountdown = function() {
  console.log("Resetuji denní countdown");
  
  const countdowns = document.querySelectorAll('.countd_all');
  countdowns.forEach(function(countdown) {
    if (countdown.getAttribute('data-daily-reset') === 'true') {
      // Vytvoříme zítřejší datum v půlnoci
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);
      
      // Formátujeme datum
      const year = tomorrow.getFullYear();
      const month = (tomorrow.getMonth() + 1).toString().padStart(2, '0');
      const day = tomorrow.getDate().toString().padStart(2, '0');
      
      // Nastavíme nové datum
      const newDate = `${year}/${month}/${day}`;
      countdown.setAttribute('data-date', newDate);
      
      // Reloadneme stránku, aby se countdown resetoval
      // Alternativně můžete zkusit najít a zavolat funkci původního skriptu pro reinicializaci
      location.reload();
    }
  });
};